(function () {
  'use strict';

  const gate = document.querySelector('.LockGate');
  if (!gate) return;

  const lockId = gate.dataset.lockId;
  const lockSalt = gate.dataset.lockSalt || '';
  const form = gate.querySelector('[data-lock-form]');
  const errorEl = gate.querySelector('[data-lock-error]');
  const busyEl = gate.querySelector('[data-lock-busy]');
  const input = form ? form.querySelector('input[name="password"]') : null;
  const submitBtn = form ? form.querySelector('button[type="submit"]') : null;

  async function sha256Hex(text) {
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
    return Array.from(new Uint8Array(buf))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  }

  // fetch は 4xx/5xx を reject しないため明示 throw。握り潰すと reload ループの原因になる。
  async function postCartAttributes(attributes) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    });
    if (!res.ok) {
      const err = new Error('cart_update_failed');
      err.status = res.status;
      throw err;
    }
    return res;
  }

  function showBusy() {
    if (busyEl) busyEl.hidden = false;
  }

  function stopLoadingMask() {
    document.documentElement.classList.remove('LockGate-loading');
  }

  async function handleSecretLink() {
    // URL ゲート通過後は data-url-gate-passed を見て早期 return（リロードループ防止）
    if (gate.dataset.urlGatePassed === 'true') return false;
    const params = new URLSearchParams(window.location.search);
    const ls = params.get('ls');
    if (!ls) return false;
    // 同じ ?ls= が既に cart に書き込み済み（= 一度試行して無効と判明）なら再 POST しない。
    // 別の ?ls= に切り替えたときだけ書き込みが走る。
    if (ls === gate.dataset.urlTokenCurrent) {
      stopLoadingMask();
      return false;
    }
    try {
      await postCartAttributes({ _cover_lock_url_token: ls });
      window.location.reload();
      return true;
    } catch (e) {
      // restricted（無効パス扱い）と区別するため通信エラーを明示
      stopLoadingMask();
      showBusy();
      return false;
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!input) return;
    const pwd = input.value.trim();
    if (!pwd) return;

    if (submitBtn) submitBtn.disabled = true;
    if (errorEl) errorEl.hidden = true;
    if (busyEl) busyEl.hidden = true;

    try {
      const hash = await sha256Hex(pwd + lockSalt);
      await postCartAttributes({ _cover_lock_attempt: lockId + ':' + hash });
      window.location.reload();
    } catch (e) {
      // cart 更新失敗 = 誤入力ではない。error を出すと誤誘導になるため busy に倒す
      showBusy();
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  if (form) form.addEventListener('submit', handleSubmit);

  handleSecretLink();
})();
